var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Autoplay } from "swiper";
class AwardsSwiper {
    constructor(element, args) {
        //console.log({ element, args });
        this.element = element;
        this.args = args;
        this.initSwiper();
    }
    initSwiper() {
        import("swiper").then((module) => __awaiter(this, void 0, void 0, function* () {
            const Swiper = module.default;
            return new Swiper(this.element, {
                modules: [Autoplay],
                allowTouchMove: false,
                autoplay: {
                    delay: 0.5,
                },
                speed: 7000,
                slidesPerView: "auto",
                spaceBetween: 20,
                loop: true,
                on: {
                    init(swiper) {
                        setTimeout(() => {
                            swiper.el.classList.add("loaded");
                        }, 10);
                    },
                },
            });
        }));
    }
}
export default AwardsSwiper;
